// Keep in sync with MAX_FILE_SIZE_MB in server/.env
export const MAX_FILE_SIZE_MB = 50;

export function formatBytes(bytes = 0) {
    if (!bytes) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    return `${(bytes / 1024 ** i).toFixed(i ? 1 : 0)} ${units[i]}`;
}

export function formatDate(value) {
    if (!value) return '-';
    return new Date(value).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function formatDay(value) {
    if (!value) return '-';
    return new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

export function formatMoney(value = 0) {
    return Number(value).toLocaleString('en-IN', { maximumFractionDigits: 2 });
}

// Price of a single unit; null when there is no quantity to divide by
export function unitPrice(item) {
    return item?.quantity > 0 ? item.price / item.quantity : null;
}

export function getExtension(name = '') {
    const i = name.lastIndexOf('.');
    return i >= 0 ? name.slice(i).toLowerCase() : '';
}

export const FILE_TYPE_ICON = {
    image: 'fa-file-image-o',
    pdf: 'fa-file-pdf-o',
    word: 'fa-file-word-o',
    excel: 'fa-file-excel-o',
    text: 'fa-file-text-o',
    other: 'fa-file-o',
};

const TYPE_BY_EXTENSION = {
    '.png': 'image', '.jpg': 'image', '.jpeg': 'image', '.gif': 'image', '.webp': 'image', '.tif': 'image', '.tiff': 'image',
    '.pdf': 'pdf', '.doc': 'word', '.docx': 'word', '.xls': 'excel', '.xlsx': 'excel', '.csv': 'excel', '.txt': 'text',
};

export function fileTypeFromName(name) {
    return TYPE_BY_EXTENSION[getExtension(name)] || 'other';
}

export function getErrorMessage(err, fallback = 'Something went wrong') {
    if (err?.response?.data?.message) return err.response.data.message;
    if (err?.message === 'Network Error') return 'Cannot reach the server. Is it running on port 5050?';
    return err?.message || fallback;
}
